import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { selectCaptchaEnabled, selectTurnstileSiteKey } from '../../global-selectors';
import { useTurnstile } from '../../utils/hooks/useTurnstile';
import { TurnstileCaptcha } from '../../components/form/CaptchaTurnstile';


export const withCaptcha = (WrappedComponent) => {
  const WithCaptchaComponent = ({ siteKey, isCaptchaEnabled, ...props }) => {
    const {
      token,
      execute,
      reset,
      isVerifying,
      handleVerify,
      handleExpire,
      turnstileRef
    } = useTurnstile();

    return (
      <>
        <WrappedComponent
        {...props}
        captchaToken={token}
        executeCaptcha={execute}
        resetCaptcha={reset}
        isCaptchaVerifying={isVerifying}
        isCaptchaEnabled={isCaptchaEnabled}
        />
        <br />
        {
            isCaptchaEnabled && 
            <TurnstileCaptcha
            ref={turnstileRef}
            sitekey={siteKey}
            size="flexible"
            appearance="execute"
            theme="dark"
            onVerify={handleVerify}
            onExpire={handleExpire}
            />
        }
      </>
    );
  };

  WithCaptchaComponent.propTypes = {
    siteKey: PropTypes.string.isRequired,
    isCaptchaEnabled: PropTypes.bool.isRequired
  };

  return WithCaptchaComponent;
};


const mapStateToProps = (state) => ({
  siteKey: selectTurnstileSiteKey(state),
  isCaptchaEnabled: selectCaptchaEnabled(state)
});

export default compose(connect(mapStateToProps), withCaptcha);
